export const InterestRate = {
  BankAnalysisAssumptions: {
    Data: {}
  }
}
